/* tempexp_18086-start */
import React, { useCallback } from 'react';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';

import { closeReferralDisabledModal } from './ReferralDisabledModal.helpers';

export interface ReferralDisabledModalProps {
    onClose?(): void;
    onShow(): void;
    onClick(): void;
}

export function ReferralDisabledModal({ onClose, onClick, onShow }: ReferralDisabledModalProps) {
    const handleClick = useCallback(() => {
        onClick();
        closeReferralDisabledModal();
    }, [onClick]);
    return (
        <BaseConfirmDialog
            dataQAId="referral-disabled-dialog"
            renderHeader={() => 'Не\u00A0получится забрать скидку по\u00A0приглашению'}
            renderContent={() => 'С\u00A0вами поделились реферальной ссылкой, но\u00A0у\u00A0вас уже есть подписка Mail Space'}
            size="average"
            buttonTheme="vk"
            buttons={[EButtonType.accept]}
            successButtonText="Перейти к тарифам"
            onClose={onClose}
            onShow={onShow}
            onSuccess={handleClick}
        />
    );
}

/* tempexp_18086-end */
